module.exports = __webpack_public_path__ + "img/infinity-war.d40e27a.png";